import { useCallback, useRef, useState } from 'react';
import { getOffScreenNodeElement }       from '../views/containers/OffScreenNode';
import { runIfFunction }                 from '../util';

type UseOffScreenNodeElementToggleHookMethod = () => OffScreenNodeElementToggleHook;

export type OffScreenNodeElementToggleHook = {
	toggleState: boolean,
	setToggleFunction: ( func: Function ) => void,
	setToggleState: ( stateValue: boolean ) => void,
	attachOffScreenToggleClickHandler: () => void,
	removeOffScreenToggleClickHandler: () => void,
};

export const useOffScreenNodeElementToggle: UseOffScreenNodeElementToggleHookMethod = () => {
	
	const [ toggleState, setState ] = useState( false );
	
	const toggleFunction = useRef<Function>( null );
	
	const offScreenNodeElementListener = () => {
		
		runIfFunction( toggleFunction.current );
	};
	
	const attachOffScreenToggleClickHandler: OffScreenNodeElementToggleHook['attachOffScreenToggleClickHandler'] = useCallback( () => {
		
		getOffScreenNodeElement().addEventListener( 'click', offScreenNodeElementListener );
		
	}, [] );
	
	const removeOffScreenToggleClickHandler: OffScreenNodeElementToggleHook['removeOffScreenToggleClickHandler'] = useCallback( () => {
		
		getOffScreenNodeElement().removeEventListener( 'click', offScreenNodeElementListener )
		
	}, [] );
	
	const setToggleFunction: OffScreenNodeElementToggleHook['setToggleFunction'] = ( func = () => {} ) => {
		
		toggleFunction.current = func;
	}
	
	const setToggleState: OffScreenNodeElementToggleHook['setToggleState'] = ( stateValue ) => {
		
		setState( stateValue );
	}
	
	return {
		toggleState,
		setToggleFunction,
		setToggleState,
		attachOffScreenToggleClickHandler,
		removeOffScreenToggleClickHandler,
	};
};
